import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetBankingList } from "../../store/bankingAtom";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";


function BankingScroll({ onSelection, viewItemDetails }) {
  const getRecoilList = GetBankingList();
  const [tableData, setTableData] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    setTableData(getRecoilList?.bank_info.map((ele) => ({ ...ele, checked: false })));
  }, [getRecoilList]);

  const onCheckboxClick = async (e, index) => {
    let element = tableData[index];
    tableData[index] = { ...element, checked: e.target.checked };
    await setTableData([...tableData]);
    onSelection(tableData);
  };

  const manageStatus = (statusCode, statusName) => {
    let defaultClass = 'text-blue-600';
    switch (statusCode) {
      case 1: defaultClass = 'text-green-600'; break;
      case 2: defaultClass = 'text-yellow-600'; break;
      case 3: defaultClass = 'text-red-600'; break;
      case 4: defaultClass = 'text-purple-600'; break;
      case 5: defaultClass = 'text-orange-600'; break;
      case 6: defaultClass = 'text-gray-600'; break;
      default: break;
    }
    return (
      <span className={`text-sm font-semibold ${defaultClass}`}>
        {statusName}
      </span>
    );
  };

  return (
    <section className="mt-4 border border-gray-200 rounded-lg bg-white shadow-sm">
      {tableData?.map((info, index) => (
        <div
          key={index}
          onClick={() => viewItemDetails(info?.account_id)}
          className={`flex items-center p-3 border-b border-gray-200 hover:bg-gray-50 cursor-pointer transition-colors duration-200 ${
            Number(id) === info?.account_id ? 'bg-blue-50' : ''
          }`}
        >
          <div className="flex items-center space-x-3 w-full">
            <input
              type="checkbox"
              checked={info?.checked || false}
              onChange={(e) => onCheckboxClick(e, index)}
              className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <div className="flex-1">
              <div className="font-semibold text-gray-800 text-sm">{info?.currency_name_short}{formatCustomNumber(info?.amount)}</div>
              <div className="text-sm text-gray-500 italic">{info?.account_name}</div>
              <div className="text-sm text-gray-600">{info?.account_id}</div>
            </div>
            {/* <div className="text-sm font-semibold text-gray-700">{info?.Bag_Quantity}</div> */}
          </div>
        </div>
      ))}
    </section>
  );
}

export default BankingScroll;